import * as _ from 'lodash';
import * as types from '../../mutationTypes';

/* eslint-disable no-param-reassign */
export default {
  [types.RESET_PAGE_VISIBILITIES](state) {
    state.pages = [];
  },

  [types.SET_INVISIBLE_PAGES](state, { module, pages }) {
    const moduleId = parseInt(module, 10);
    state.pages = _.filter(state.pages, (page) => page.module !== moduleId);
    state.pages = state.pages.concat(_.map(pages, (page) => ({ page, visible: false, module })));
  }
};

/* eslint-enable no-param-reassign */
